import { useQuery } from '@tanstack/react-query';

import { transportationApi } from '~endpoints/Transportation';
import { pointToPointTicketKeys } from '~queryKeys/transportation/pointToPointTicket';

export async function getTransportProducts() {
  return transportationApi.v1.RailEurope.getTransportProducts();
}

const useTransportProducts = () => {
  return useQuery({
    queryKey: pointToPointTicketKeys.transportProducts(),
    queryFn: () => getTransportProducts().then((res) => res.data),
    staleTime: Infinity,
  });
};

export default useTransportProducts;
